/**
 * Defines the version of the page layout to be used for a given page. This is being used for
 * purposes of supporting the rollout of new page layouts incrementally.
 *
 * All new pages should be assigned {@link PageLayoutVersion.Version2}, and existing pages should be
 * migrated to {@link PageLayoutVersion.Version2} as part of any significant updates to those pages.
 *
 * The older version, {@link PageLayoutVersion.Version1}, does not render the outer app shell
 * and layout in the _app.tsx file, but rather expects each page to include the necessary layout
 * components within the page component itself.  These components are usually things such as
 * {@link StandardPageContainer}, etc.
 *
 * The new {@link PageLayoutVersion.Version2} relies on the new layout system in the _app.tsx file,
 * which renders the outer app shell and layout for all pages, allowing page components to override
 * this layout or define nested layouts via the 'getLayout' and 'getNestedLayout' methods, which
 * ensures that page navigation does not result in unnecessary re-rendering of common/shared layout
 * elements and state is preserved.
 */
export enum PageLayoutVersion {
  Version1 = 'v1',
  Version2 = 'v2',
}

export enum PageIntegration {
  UserFlow = 'userflow',
}
